// extracted by mini-css-extract-plugin
module.exports = {"tableCellAttachments":"table-cell-attachments--tableCellAttachments--1npfR8G"};